/**
 * Created by mark on 05/03/2018.
 */


import React  from 'react';
import Wizard from '../wizards/wizard.js';
import {Upload , SelectField , Completed , Comfirmation} from '../wizards/import';
import {Translation} from '../../store';

export default class StudentImport extends React.Component {

    constructor(props) {
        super(props);

    }

    renderPanelHeader(){
        return <div>
            <h1>{Translation.get(12654 , 'Import Students')}</h1>
        </div>
    }

    render() {

        let Steps = [Upload , SelectField , Comfirmation , Completed];
        return <div>
                <Wizard name="" stepsNavigation={true} steps={Steps} />
        </div>;
    }

}


